module.exports = __webpack_public_path__ + "static/bet365-casino-logo-300x190-ed5df9563687227195e7d580ab38b1b8.png";